import React from "react";

function EmoshareIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <img alt={'logo-emoshare'} src={process.env.PUBLIC_URL + '/images/logo_resized.png'} width={props.width}/>
  );
}

export default EmoshareIcon;
